<button 
  *ngIf="isVisible"
  class="scroll-to-top-btn"
  [class.exiting]="isExiting"
  (click)="scrollToTop()"
  aria-label="Scroll to top">
  
  <div class="icon-container">
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      stroke-width="3" 
      stroke-linecap="round" 
      stroke-linejoin="round"
      class="arrow-icon">
      <polyline points="18 15 12 9 6 15"></polyline>
    </svg>
  </div>
  
  <div class="text-container">
    <span>Scroll to top</span>
  </div>
</button>
